import { render } from "./StartGameTeamMultiNames.vue?vue&type=template&id=a4ea6388"
import script from "./StartGameTeamMultiNames.vue?vue&type=script&lang=js"
export * from "./StartGameTeamMultiNames.vue?vue&type=script&lang=js"

import "./StartGameTeamMultiNames.vue?vue&type=style&index=0&id=a4ea6388&lang=css"

import exportComponent from "/Users/robert.bryden/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__